import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { labelStyle, inputErrorColor } from '../../styles/formsLight';
export var NormalizeLabel = styled.label(_templateObject());
export var Label = styled.div(_templateObject2(), function (_ref) {
  var label = _ref.label;
  return label && labelStyle;
}, function (_ref2) {
  var error = _ref2.error;
  return error && "\n    color: ".concat(inputErrorColor, ";\n  ");
});